<!--添加/编辑充电枪 form表单-->
<template>
    <v-card :color="theme.elementBgColor" v-loading.fullscreen.lock="addLoading">
        <v-card-title>
            {{ form.id ? form.name : "添加充电枪" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="8vw" class="pb-6" label-position="top">
                <el-form-item label="站点" :rules="[{ required: true }]">
                    <select-site
                        v-if="isSite"
                        :selectSite="form.selectSite"
                        @choose="chooseSite"
                        :width="'60%'"
                    />
                </el-form-item>
                <el-form-item label="充电桩" :rules="[{ required: true }]">
                    <select-pile
                        v-if="isSite"
                        @choose="choosePile"
                        :siteId="form.selectSite"
                        :width="'60%'"
                        :multiple="multiple"
                        :pileId="form.equipment_id"
                    />
                </el-form-item>
                <!-- <el-form-item label="互联互通">
                    <select-cec :width="'60%'" :cecId="form.cec_id" @chooseCec="chooseCec" />
                </el-form-item> -->
                <el-form-item label="充电枪名称" :rules="[{ required: true }]">
                    <el-input v-model="form.name" autocomplete="off" style="width: 60%">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="充电枪编号" :rules="[{ required: true }]">
                    <el-input
                        v-model="form.connector_id"
                        autocomplete="off"
                        @input="inputSerial"
                        clearable
                        style="width: 60%"
                    >
                        <i class="el-icon-edit" slot="prepend"></i>
                        <template v-if="isHave" slot="append">
                            此设备编号已存在
                        </template>
                    </el-input>
                </el-form-item>
                <!-- <el-form-item label="电流" :rules="[{ required: true }]">
                    <el-input v-model="form.current" autocomplete="off">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item> -->
                <el-form-item label="" :rules="[{ required: true }]">
                    <div style="display:flex;flex-direction:row;align-items:center;">
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.v_upper" autocomplete="off" placeholder="">
                                    <span slot="prepend">电压上限</span>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div style="width:10%"></div>
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.v_lower" autocomplete="off" placeholder="">
                                    <span slot="prepend">电压下限</span>
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" :rules="[{ required: true }]">
                    <div style="display:flex;flex-direction:row;align-items:center;">
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.current" autocomplete="off" placeholder="">
                                    <span slot="prepend">电流</span>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div style="width:10%"></div>
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.power" autocomplete="off" placeholder="">
                                    <span slot="prepend">额定功率</span>
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form-item>
                <!-- <el-form-item label="额定功率" :rules="[{ required: true }]">
                    <el-input v-model="form.power" autocomplete="off">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item> -->
                <el-form-item label="设备类型" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in typeText"
                        :key="index"
                        v-model="form.type"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
                <el-form-item label="设备状态" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in statusText"
                        :key="index"
                        v-model="form.status"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import util from "@/util";
import Public from "@/public"
import SelectSite from "@/components/SelectSite";
import SelectPile from "@/components/SelectPile";
import SelectCec from "@/components/SelectCec";
import { mapState } from "vuex";
import store from "@/store";
export default {
    data() {
        return {
            form: {
                id: null,
                name: null,
                connector_id: null,
                equipment_id: null, //选中的充电桩id
                selectSite: null, //选中的站点id
                // cec_id: null,
                current: null,
                power: null,
                status: null,
                type: null,
                updatetime: null,
                v_lower: null,
                v_upper: null,
            },
            isSite: true,
            multiple: false, //充电桩是否多选
            connectorIdArray: null,
            isHave: false,
            typeText: [
                {
                    id: 1,
                    value: "家用插座",
                },
                {
                    id: 2,
                    value: "交流插座",
                },
                {
                    id: 3,
                    value: "交流桩",
                },
                {
                    id: 4,
                    value: "直流桩",
                },
                {
                    id: 5,
                    value: "无线",
                },
                {
                    id: 6,
                    value: "其他",
                },
            ],
            statusText: [
                {
                    id: 0,
                    value: "离线",
                },
                {
                    id: 1,
                    value: "空闲",
                },
                {
                    id: 2,
                    value: "占用（未充电）",
                },
                {
                    id: 3,
                    value: "占用（充电中）",
                },
                {
                    id: 4,
                    value: "占用（预约锁定）",
                },
                {
                    id: 254,
                    value: "冻结",
                },
                {
                    id: 255,
                    value: "故障",
                },
            ],
            oldConnectorId: null, //未修改的充电枪编码
            addLoading: false,
        };
    },
    watch: {
        "form.selectSite": {
            handler(val) {
                if (!this.station_id && this.isEdit) {
                    this.isSite = false;
                    this.$nextTick(() => {
                        this.isSite = true;
                    });
                }
            },
            deep: true,
        },
        "form.connector_id": {
            handler(val) {
                if (!val) {
                    this.isHave = false;
                }
            },
            deep: true,
        },
        contactInfo: {
            handler(val) {
                // this.connectorIdArray = [];
                // for (let i = 0; i < this.gunInfos.length; i++) {
                //     this.connectorIdArray.push(this.gunInfos[i].connector_id);
                // }
                this.getConnectorInfo();
            },
            deep: true,
        },
        gunData: {
            handler(val) {
                if (val) {
                    Object.keys(this.form).forEach(key => {
                        this.form[key] = val[key];
                        if (val["status"] === "0") {
                            this.form["status"] = 0;
                        }
                    });
                }
            },
            deep: true,
        },
        isAdd: {
            handler(val) {
                if (val) {
                    Object.keys(this.form).forEach(key => {
                        this.form[key] = null;
                    });
                }
            },
            deep: true,
        },
        station_id: {
            handler(val) {
                if (val) {
                    this.form["selectSite"] = val;
                }
            },
        },
    },
    created() {
        // Object.keys(this.form).forEach(key => {
        //     this.form[key] = null;
        // });
    },
    mounted() {
        if (this.gunData) {
            Object.keys(this.form).forEach(key => {
                this.form[key] = this.gunData[key];
            });
        }
        if (this.isAdd && this.station_id) {
            this.form["selectSite"] = this.station_id;
        }
        this.oldConnectorId = this.form["connector_id"];
        this.getConnectorInfo();
    },
    props: {
        isAdd: Boolean,
        isEdit: Boolean,
        station_id: Number,
    },
    components: {
        SelectSite,
        SelectPile,
        SelectCec,
    },
    computed: {
        ...mapState(["contactInfo", "connectorInfo", "gunData", "TipType", "theme"]),
    },
    methods: {
        // chooseCec(cecId) {
        //     this.form["cec_id"] = cecId;
        // },
        /*选择站点*/
        async chooseSite(site) {
            this.form["selectSite"] = site.siteId;
            this.form["equipment_id"] = null;
            // this.form["cec_id"] = site.cecId;
            let postData = {
                station_id: site.siteId,
                // from: 0,
                // limit: 10000,
            };
            await store.dispatch("getConnector", postData);
        },
        /*获取充电枪数据 用于判断是否存在相同的充电枪编号*/
        async getConnectorInfo() {
            let postData = {
                station_id: this.form["selectSite"],
                // from: 0,
                // limit: 10000,
            };
            await store.dispatch("getConnector", postData);
            this.gunInfos = JSON.parse(JSON.stringify(this.connectorInfo.reverse()));
            this.connectorIdArray = [];
            for (let i = 0; i < this.gunInfos.length; i++) {
                this.connectorIdArray.push(this.gunInfos[i].connector_id);
            }
        },
        /*选择充电桩*/
        choosePile(pile) {
            console.log(pile);
            this.form["equipment_id"] = pile;
        },
        /*获取当前时间格式为 yyyy-mm-dd hh-mm-ss*/
        getFormatDate() {
            var date = new Date();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentDate =
                date.getFullYear() +
                "-" +
                month +
                "-" +
                strDate +
                " " +
                date.getHours() +
                ":" +
                date.getMinutes() +
                ":" +
                date.getSeconds();
            return currentDate;
        },
        /*确定添加*/
        determine() {
            // if (this.form.status == 0) {
            //     delete this.form.status;
            // }
            this.form.updatetime = this.getFormatDate();
            delete this.form.updatetime;
            let params = {
                postData: { connector: {} },
                callback: () => {
                    this.addLoading = false;
                    this.$emit("refresh");
                    this.cancel();
                },
            };
            let form = Object.assign({}, this.form);
            if (this.isAdd) {
                delete form.id;
            }
            // delete form.cec_id;
            delete form.selectSite;
            delete form.status;
            let nullKeyArr = Object.keys(form).filter(key => !form[key]);
            if (nullKeyArr.length <= 0 && this.form["status"] != null) {
                Object.keys(this.form).forEach(key => {
                    if (key == "connector_id" || key == "name" || key == "current" || key == "power" || key == "v_lower" || key == "v_upper") {
                        this.form[key] = Public.removeSpace(this.form[key])
                    }
                    if (this.isAdd && key != "id") {
                        if (
                            key == "type" ||
                            key == "current" ||
                            key == "power" ||
                            key == "v_lower" ||
                            key == "v_upper" ||
                            key == "status"
                        ) {
                            params.postData.connector[key] = Number(this.form[key]);
                        } else if (key != "selectSite") {
                            params.postData.connector[key] = this.form[key];
                        }
                    } else if (this.isEdit) {
                        if (
                            key == "type" ||
                            key == "current" ||
                            key == "power" ||
                            key == "v_lower" ||
                            key == "v_upper" ||
                            key == "status"
                        ) {
                            params.postData.connector[key] = Number(this.form[key]);
                        } else if (key != "selectSite") {
                            params.postData.connector[key] = this.form[key];
                        }
                    } else if (key === "cec_id") {
                        // if (!this.form["cec_id"]) {
                        //     delete this.form["cec_id"];
                        // } else {
                        //     params.postData.connector["cec_id"] = this.form["cec_id"];
                        // }
                    }
                });
                // if (!this.form["status"]) {
                //     params.postData.connector["status"] = 0;
                // }
            } else {
                let utilText = "";
                for (let i1 = 0; i1 < nullKeyArr.length; i1++) {
                    if (i1 == nullKeyArr.length - 1) {
                        utilText = utilText + this.utilText(nullKeyArr[i1]);
                    } else {
                        utilText = utilText + this.utilText(nullKeyArr[i1]) + "、";
                    }
                }
                if (this.form["status"] == null) {
                    if (utilText != "") {
                        utilText = utilText + "、设备状态";
                    } else {
                        utilText = "设备状态";
                    }
                }
                util.ShowTip(utilText + "不能为空", 3);
                return;
            }
            this.addLoading = true;
            if (this.isAdd && this.isEdit === false) {
                store.dispatch("addConnector", params);
            } else if (this.isEdit && this.isAdd === false) {
                store.dispatch("updateConnector", params);
                params.postData.connector.selectSite = this.form.selectSite;
                store.commit("SET_GUN_DETAIL", params.postData.connector);
            }
        },
        /*返回相应为空值指的文本*/
        utilText(key) {
            let text = "";
            if (key == "name") {
                text = "充电枪名称";
            } else if (key == "connector_id") {
                text = "充电枪编号";
            } else if (key == "equipment_id") {
                text = "充电桩";
            } else if (key == "current") {
                text = "电流";
            } else if (key == "power") {
                text = "功率";
            } else if (key == "type") {
                text = "设备类型";
            } else if (key == "v_lower") {
                text = "电压下限";
            } else if (key == "v_upper") {
                text = "电压上限";
            }
            return text;
        },
        /*取消添加*/
        cancel() {
            if (this.isAdd) {
                Object.keys(this.form).forEach(key => {
                    this.form[key] = null;
                });
            }
            this.$emit("cancel");
        },
        /*充电枪编码输入框 判断是否已经存在充电枪编码*/
        inputSerial(e) {
            if (e.length <= 0) {
                return;
            }
            this.isHave = false;
            for (let i = 0; i < this.connectorIdArray.length; i++) {
                if (e.replace(/(^\s*)|(\s*$)/g, "") == this.connectorIdArray[i]) {
                    this.isHave = true;
                }
            }
            if (this.oldConnectorId == e) {
                this.isHave = false;
            }
        },
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
    },
};
</script>
